// extracted by mini-css-extract-plugin
export default {"Badge":"badge_Badge__Sd00e"};